"use client";

import React from "react";

export function ThreatModel() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20 ">
          <div>
            <h2 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[45px] lg:text-[45px] max-w-[500px]">
            Umfassende Bedrohungsmodellierung: Schutz Ihrer Systeme vor aufkommenden Cyber-Risiken
            </h2>
            <p className="mb-6 md:mb-8 md:text-md">
            Threat Modelling ist für die Identifizierung und Priorisierung von Schwachstellen in Ihren Systemen unerlässlich. Unser Expertenteam hilft Ihnen, potenzielle Bedrohungen wirksam zu entschärfen.
            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              {/* <div>
                <h3 className="mb-2 text-5xl font-bold md:text-5xl lg:text-6xl">
                  50%
                </h3>
                <p>
                Identifizieren Sie Schwachstellen, bevor sie zu kritischen Problemen werden.
                </p>
              </div>
              <div>
                <h3 className="mb-2 text-5xl font-bold md:text-5xl lg:text-6xl">
                  50%
                </h3>
                <p>Minimieren Sie Risiken mit maßgeschneiderten Sicherheitsstrategien.</p>
              </div> */}
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
